window.AddonRegistry = window.AddonRegistry || {};
window.AddonKeys = window.AddonKeys || {};
// window.baseProductPrice = 0;
// window.baseComparePrice = 0;

  // window.AddonKeys = {};   // shared store for all line-item keys

  window.initAddon = function(config) {
    const { variantId, quantity, uniqueId, autoATC } = config;

    let isOn = true;
    let isProcessing = false;


    const wrap  = document.querySelector('.' + uniqueId);
    const card  = wrap.querySelector('#addonCard');
    const track = wrap.querySelector('#toggleTrack');
    const msg   = wrap.querySelector('#stateMsg');

    window.AddonRegistry[uniqueId] = {
  addToCart,
  removeFromCart,
  setUI
};


card.addEventListener('click', (e) => {
  e.stopPropagation();
  // toggleAddon();
});
    /* ── UI state ── */
    function setUI(on) {
      isOn = on;
      track.classList.toggle('on', on);
      card.setAttribute('aria-checked', String(on));
      msg.textContent = on ? '✓ Pre-selected — tap to remove' : 'Not included — tap to add';
      msg.style.color = on ? '#2a7a1e' : '#999';
    }

    function setLoading(loading) {
      card.style.opacity       = loading ? '0.7' : '1';
      card.style.pointerEvents = loading ? 'none' : '';

      if(loading) {
        isProcessing = true
        console.log('its loading')
      } else {
        isProcessing = false
        console.log('It finished loading')
      }
    }

    /* ── Cart helpers ── */
    async function addToCart() {
      if (isProcessing) return;
      // setUI(true);
      setLoading(true);
      
      try {
        const res  = await fetch(window.Shopify.routes.root + 'cart/add.js', {
          method:  'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body:    JSON.stringify({ items: [{ id: variantId, quantity }] })
        });
        if (!res.ok) throw new Error('add failed');
        const data = await res.json();
        window.AddonKeys[uniqueId] = data.items?.[0]?.key ?? null;
        setUI(true);
        refreshCartUI();
        updateAddonAffectedPrices(Number(window.baseProductPrice || 0),Number(window.baseComparePrice || 0));
        
      } catch (err) {
        console.error('[addon] addToCart:', err);
        setUI(false);
      } finally {
        setLoading(false);
      }
    }

    async function removeFromCart() {
      if (isProcessing) return;
      if (!window.AddonKeys[uniqueId]) return;
      setUI(false);
      setLoading(true);
      try {
        const res = await fetch(window.Shopify.routes.root + 'cart/change.js', {
          method:  'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body:    JSON.stringify({ id: window.AddonKeys[uniqueId], quantity: 0 })
        });
        if (!res.ok) throw new Error('remove failed');
        window.AddonKeys[uniqueId] = null;
        setUI(false);
        refreshCartUI();
        updateAddonAffectedPrices(Number(window.baseProductPrice || 0),Number(window.baseComparePrice || 0));
        
      } catch (err) {
        console.error('[addon] removeFromCart:', err);
        setUI(true);
      } finally {
        setLoading(false);
      }
    }

    function refreshCartUI() {
      document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart-update',  { bubbles: true }));
      fetch(window.Shopify.routes.root + 'cart.js')
        .then(r => r.json())
        .then(cart => {
          document.querySelectorAll('.cart-count-bubble span').forEach(el => {
            el.textContent = cart.item_count;
          });
        });
    }

    async function toggleAddon() {
      const next = !isOn;
      setUI(next);
      if (next) { await addToCart(); } else { await removeFromCart(); }
    }

    /* ── Event listeners ── */
    card.addEventListener('click', toggleAddon);
    card.addEventListener('keydown', e => {
      if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); toggleAddon(); }
    });


    console.log(`It is test page: ${autoATC} id ; ${variantId} qty: ${quantity}`)
    /* ── Auto-add on load ── */
    // if (autoATC) {
    //   console.log(addToCart)
    //   setTimeout( async () => {
    //     await addToCart()
    //   }, 2000);
    // }
    
    if (autoATC) {
  const run = async () => {
    await addToCart();
  };

  if (document.readyState === 'complete') {
    run();
  } else {
    window.addEventListener('load', run, { once: true });
  }
}
    
  };


  (window.addonQueue || []).forEach(function (config) {
  window.initAddon(config);
});


document.querySelectorAll(
  '.quantity-breaks-container label:nth-child(2), .quantity-breaks-container label:nth-child(4)'
).forEach((label, index) => {
  label.addEventListener('click', async () => {
    
    const isSet1 = index === 0;

    if (isSet1) {
       window.baseProductPrice = label.dataset?.price
      window.baseComparePrice = label.dataset?.comparePrice
      await window.AddonRegistry['set1']?.setUI(true)
      await window.AddonRegistry['set2']?.removeFromCart();
      await window.AddonRegistry['set1']?.addToCart();
     
    } else {
      window.baseProductPrice = label.dataset?.price
      window.baseComparePrice = label.dataset?.comparePrice
            await window.AddonRegistry['set2']?.setUI(true)
      await window.AddonRegistry['set1']?.removeFromCart();
      await window.AddonRegistry['set2']?.addToCart();
      
    }
  });
});


// Price update

  function updateAddonAffectedPrices(basePrice,baseComparePrice) {
  const mainPriceEl = document.querySelectorAll('.price .main-price')[1];
  const comparePriceEl = document.querySelectorAll('.price .main-comapre-price')[1];
  const atcPriceEl = document.querySelector('.main-atc-price');



  let addonPriceTotal = 0;
  let addonCompareTotal = 0;

  Object.keys(window.AddonKeys || {}).forEach((key) => {
    if (window.AddonKeys[key] && window.addonPrices?.[key]) {
      addonPriceTotal += Number(window.addonPrices[key].price || 0);
      addonCompareTotal += Number(window.addonPrices[key].comparePrice || 0);
    }
  });

  console.log(basePrice, addonPriceTotal)
  const finalPrice = basePrice + addonPriceTotal;
  const finalComparePrice = baseComparePrice + addonCompareTotal;

  if (mainPriceEl) {
    // mainPriceEl.innerHTML = formatMarketCurrency(finalPrice);
  }

  if (atcPriceEl) {
    atcPriceEl.innerHTML = formatMarketCurrency(finalPrice);
  }

  if (comparePriceEl) {
    if (finalComparePrice > finalPrice) {
      // comparePriceEl.innerHTML = formatMarketCurrency(finalComparePrice);
      // comparePriceEl.style.display = '';
    } else {
      // comparePriceEl.innerHTML = '';
      // comparePriceEl.style.display = 'none';
    }
  }
}